export const PHONE_DISPLAY = "541-233-2358";
export const PHONE_HREF = "tel:+15412332358";
export const EMAIL = "info@cbwebsites.co";
export const EMAIL_HREF = "mailto:info@cbwebsites.co";
export const BRAND_NAME = "CB Websites";
export const PRIMARY_CTA_LABEL = "Get Your Demo Funnel";

/**
 * Primary CTA click handler — always scroll to the contact form
 * and focus the Name field. Phone is no longer the primary conversion
 * for the appointment / membership niches we serve.
 */
export function handlePrimaryCta(e) {
  if (typeof window === "undefined") return;
  if (e && typeof e.preventDefault === "function") e.preventDefault();
  const section = document.getElementById("contact");
  if (!section) return;
  section.scrollIntoView({ behavior: "smooth", block: "start" });
  window.setTimeout(() => {
    const firstField = section.querySelector('[data-testid="contact-input-name"]');
    if (firstField && typeof firstField.focus === "function") {
      firstField.focus({ preventScroll: true });
    }
  }, 650);
}
